import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

export const requestPageTranslationRef = createTranslationRef({
  id: 'request-page',
  messages: {
    requestPage: {
      title: 'Requests',
      subtitle: 'Pending Component Creation Requests',
      pageTitleOverride: 'Requests',
      createButtonTitle: 'Register Existing Request',
      supportButtonTitle: 'All your Requests',
      myRequestsTitle: 'My Requests',
      toApproveTitle: 'Request to Approve',
      status: {
        pending: 'Pending approval',
        'pending-your-approval': 'Pending approval',
        'provisioning-in-progress': 'Provisioning in progress',
        'provisioning-pending': 'Provisioning pending',
        'provisioning-completed': 'Provisioning completed',
        'provisioning-failed': 'Provisioning failed',
        'provisioning-unknown': 'Provisioning unknown',
        unknown: 'Unknown',
      },
      filters: {
        fromDate: 'From Date',
        toDate: 'To Date',
        status: {
          title: 'Status',
          options: {
            all: 'All',
            pending: 'Pending',
            denied: 'Denied',
            approved: 'Approved',
          }
        },
      }
    },
    requestForm: {
      title: 'Request Information',
      details: {
        title: 'Provisioning Details',
        repository_template: 'Repository Template',
        version_template: 'Version Template',
        repository: 'Repository',
      }
    },
    requestTableColumns: {
      requestType: 'Request Type',
      name: 'Name',
      title: 'Title',
      application: 'Application',
      project: 'Project',
      component: 'Component',
      requestDate: 'Request Date',
      requester: 'Requester',
      approver: 'Approver',
      status: 'Status',
    }
  },
});

export const requestPageTranslations = createTranslationResource({
  ref: requestPageTranslationRef,
  translations: {
    en: () => import('./request-page-en'),
    es: () => import('./request-page-es'),
  },
});